export const primaryRed = 'var(--primary-red)'
export const hoverColor = 'var(--hover)'
export const backgroundColor = 'var(--background)'
export const checkBoxGrey = 'var(--border-input)'
export const AvenirMedium = 'var(--avenir-next-medium)'
export const AvenirRegular = 'var(--avenir-next-regular)'
